import styled from '@emotion/styled';
import { Button } from '@/components/atoms/Button';

export const Container = styled.div`
    width: 100%;
    padding: ${({ theme }) => theme.spacing[4]};
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${({ theme }) => theme.font.family};
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[4]};

    h2 {
        margin-bottom: 10px;
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const HeaderTitle = styled.div`
    display: flex;
    flex-direction: column;
`;

export const OptionsButton = styled(Button)`
    padding: ${({ theme }) => theme.spacing[2]};
    margin-right: ${({ theme }) => theme.spacing[2]};
    background: ${({ theme }) => theme.color.white100};
    &:hover {
        background: ${({ theme }) => theme.color.white200};
    }
    & > div {
        display: flex;
        gap: ${({ theme }) => theme.spacing[2]};
        color: ${({ theme }) => theme.color.black200};
        font-size: ${({ theme }) => theme.font.size.normal};
        font-weight: ${({ theme }) => theme.font.weight.regular};
    }
`;

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const ExportButton = styled(Button)`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[1]};
`;
